import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Portal, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import modalStyles from './AnnualReportModal.module.scss';

/** Portal overlay + orange-rail modal shell shared by the Annual Report modals (JournalEntryTemplatesModal look). */
const AnnualReportModal = ({
    open = false,
    onClose,
    title = null,
    direction = 'rtl',
    wide = false,
    compact = false,
    modalClassName = '',
    tabs = null,
    footer = null,
    children = null,
}) => {
    const { t } = useTranslation();
    if (!open) return null;

    return (
        <Portal>
            <div
                className={`${modalStyles.overlay} ${direction === 'rtl' ? modalStyles.rtl : modalStyles.ltr}`}
                onClick={onClose}
            >
                <div dir={direction} onClick={(e) => e.stopPropagation()}>
                    <div
                        className={`${modalStyles.modal}${wide ? ` ${modalStyles.modalWide}` : ''}${compact ? ` ${modalStyles.modalCompact}` : ''}${modalClassName ? ` ${modalClassName}` : ''}`}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className={modalStyles.body}>
                            <div className={modalStyles.header}>
                                <Tooltip title={t('Close') || 'Close'}>
                                    <IconButton onClick={onClose} className={modalStyles.closeIcon}>
                                        <CancelIcon className={modalStyles.closeIcon} />
                                    </IconButton>
                                </Tooltip>
                                <div className={modalStyles.headerTitle}>{title}</div>
                                <div />
                            </div>

                            {tabs}

                            <div className={modalStyles.scroll}>{children}</div>

                            {footer && <div className={modalStyles.footer}>{footer}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    );
};

AnnualReportModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.node,
    direction: PropTypes.oneOf(['rtl', 'ltr']),
    wide: PropTypes.bool,
    /** Tighter paddings and gaps for long forms, so less scrolling is needed. */
    compact: PropTypes.bool,
    /** Extra class on the modal box, e.g. to change its width. */
    modalClassName: PropTypes.string,
    tabs: PropTypes.node,
    footer: PropTypes.node,
    children: PropTypes.node,
};
export default AnnualReportModal;
